import React from 'react';
import { F9211 } from '../../../services/p922aApi';
import { fmt } from '../helpers';

interface Tab2Props {
  details: Partial<F9211>[];
  selectedRow: number;
  setSelectedRow: (idx: number) => void;
}

const Tab2MonthDetail: React.FC<Tab2Props> = React.memo(({ details, selectedRow, setSelectedRow }) => {
  // Format YYYYMM to YYYY.MM
  const formatYearMonth = (v: string | undefined): string => {
    if (!v || v.length < 6) return v || '';
    return v.substring(0, 4) + '.' + v.substring(4, 6);
  };

  // Calculate total
  const total = details.reduce((sum, d) => sum + (d.f9211_12 || 0), 0);

  return (
    <div className="tab-content-inner">
      <div className="section-title">月份明細（每月請假數）</div>

      <div className="detail-grid-wrapper">
        <table className="detail-grid">
          <thead>
            <tr>
              <th style={{ width: 50 }}>#</th>
              <th style={{ width: 120 }}>年月</th>
              <th style={{ width: 120 }}>本次請假數</th>
              <th style={{ width: 100 }}>假別單位</th>
            </tr>
          </thead>
          <tbody>
            {details.length === 0 ? (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center', padding: 16, color: 'rgba(0,0,0,0.45)' }}>
                  無月份明細資料（存檔後由系統自動計算產生）
                </td>
              </tr>
            ) : (
              details.map((d, i) => (
                <tr
                  key={i}
                  className={selectedRow === i ? 'row-selected' : ''}
                  onClick={() => setSelectedRow(i)}
                >
                  <td style={{ textAlign: 'center' }}>{i + 1}</td>
                  <td>{formatYearMonth(d.f9211_03)}</td>
                  <td style={{ textAlign: 'right' }}>{fmt(d.f9211_12)}</td>
                  <td>{d.f9211_14 || ''}</td>
                </tr>
              ))
            )}
          </tbody>
          {details.length > 0 && (
            <tfoot>
              <tr className="total-row">
                <td></td>
                <td style={{ fontWeight: 600 }}>合計</td>
                <td style={{ textAlign: 'right', fontWeight: 600 }}>{fmt(total)}</td>
                <td></td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>

      <p className="detail-note">
        月份明細由系統根據請假日期區間自動計算產生，此為唯讀資料。
      </p>
    </div>
  );
});

Tab2MonthDetail.displayName = 'Tab2MonthDetail';
export default Tab2MonthDetail;
